import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import { LoadingComponent } from "../../helpers/LoadingComponent";
import { LoginProps } from "./login.types";
import { useLoginViewModel } from "./login.vm";
import "./login.css";

export default function LoginForm(props: LoginProps) {
	const vm = useLoginViewModel(props);

	return (
		<Box className="login-form" maxWidth="md" margin="auto" component="form" onSubmit={vm.handleSubmit} noValidate>
			<TextField
				variant="outlined"
				margin="normal"
				required
				error={!!vm.emailError}
				disabled={vm.loading}
				fullWidth
				id="email"
				label="Email"
				name="email"
				autoComplete="email"
				autoFocus
				value={vm.username}
				onChange={vm.handleEmailChange}
				data-sentry-component="Email Field"
			/>
			<TextField
				variant="outlined"
				margin="normal"
				error={!!vm.passwordError}
				required
				disabled={vm.loading}
				fullWidth
				name="password"
				label="Password"
				type="password"
				id="password"
				autoComplete="current-password"
				value={vm.password}
				onChange={vm.handlePasswordChange}
				data-sentry-component="Password Field"
			/>
			<Button
				className="submit-button"
				type="submit"
				disabled={vm.isSubmitDisabled}
				fullWidth
				variant="contained"
				data-sentry-component="Submit Button"
			>
				Sign In
			</Button>
			<Typography className="error-message" variant="body2" color="textSecondary" align="center">
				{vm.error}
			</Typography>
			{vm.loading && (
				<Box display="flex" justifyContent="center" alignItems="center">
					<LoadingComponent />
				</Box>
			)}
			<Box className="button-container" display="flex">
				<Button
					disabled={vm.loading}
					onClick={vm.navigateToRegister}
					color="primary"
					variant="contained"
					data-sentry-component="Register Button"
				>
					Register
				</Button>
				<Button
					disabled={vm.loading}
					onClick={vm.navigateToForgotPassword}
					color="primary"
					variant="outlined"
					data-sentry-component="Forgot Password Button"
				>
					Forgot Password
				</Button>
			</Box>
		</Box>
	);
}
